'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { useId } from '../../util';
import { CheckboxToggle, RadioToggle, StyledDescription, HiddenInput } from './elements';
/** To apply hover states, apply `toggleParentStyles` to the label containing this component */
export const ToggleCore = /*#__PURE__*/React.forwardRef(({
  id,
  children,
  checked,
  isToggleShowing = true,
  showInteraction = true,
  onFocusChange,
  toggleType,
  ...rest
}, ref) => {
  const inputId = useId(toggleType, id);
  if (typeof children === 'string') {
    children = /*#__PURE__*/React.createElement(StyledDescription, null, children);
  }
  const ToggleComponent = toggleType === 'checkbox' ? CheckboxToggle : RadioToggle;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isToggleShowing && /*#__PURE__*/React.createElement(ToggleComponent, {
    $checked: checked,
    $showInteraction: showInteraction
  }), children, /*#__PURE__*/React.createElement(HiddenInput, _extends({
    readOnly: true,
    id: inputId,
    ref: ref
  }, rest, {
    checked: checked,
    type: toggleType,
    onFocus: () => onFocusChange === null || onFocusChange === void 0 ? void 0 : onFocusChange(true),
    onBlur: () => onFocusChange === null || onFocusChange === void 0 ? void 0 : onFocusChange(false)
  })));
});